export default "__VITE_ASSET__CkZPoitl__"